/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, GradientTexture, useTexture } from "@react-three/drei";
import { useFrame } from '@react-three/fiber';

export function Logo(props) {
  const { nodes, materials } = useGLTF("/models/JS-logo.glb");
  const boxRef = useRef();
  const [bumpMap, roughnessMap, colorMap, metalnessMap, normalMap] = useTexture(
    [
        '/MetalSteelBrushed001/MetalSteelBrushed001_BUMP_1K_METALNESS.png',
        '/MetalSteelBrushed001/MetalSteelBrushed001_ROUGHNESS_1K_METALNESS.png',
        '/MetalSteelBrushed001/MetalSteelBrushed001_COL_1K_METALNESS.png',
        '/MetalSteelBrushed001/MetalSteelBrushed001_METALNESS_1K_METALNESS.png',
        '/MetalSteelBrushed001/MetalSteelBrushed001_NRM_1K_METALNESS.png'

    ])


  useFrame(() => {
    boxRef.current.rotation.y += 0.01;
  });

  return (
    <group {...props} dispose={null} ref={boxRef} rotation-y={Math.PI * 0.25} >
      <mesh
        name="Cylinder"
        castShadow
        receiveShadow
        geometry={nodes.Cylinder.geometry}
        material={materials["Material.003"]}
        rotation={[Math.PI / 2, 0, 0]}
        >
        <meshStandardMaterial 
            color="#ffffff" 
            metalness={1} 
            roughness={0.1}
            attach="material"
            bumpMap={bumpMap}
            roughnessMap={roughnessMap}
            map={colorMap}
            metalnessMap={metalnessMap}
            normalMap={normalMap}
            
        />
      </mesh>
      <mesh
        name="Cylinder001"
        castShadow
        receiveShadow
        geometry={nodes.Cylinder001.geometry}
        material={materials["Material.005"]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.9, 1.4, 0.9]}
        >
        <meshStandardMaterial metalness={1} roughness={0.2}>
        <GradientTexture
            stops={[0, 0.3]} // As many stops as you want
            colors={['#2d8afc', '#5addc8']} // Colors need to match the number of stops
            size={1024} // Size is optional, default = 1024
        />
        </meshStandardMaterial>
      </mesh>
      <group
        name="Text"
        rotation={[-Math.PI / 2, 1.175, -Math.PI]}
        scale={[1.088, 1, 1.111]}
      >
        <mesh
          name="J"
          castShadow
          receiveShadow
          geometry={nodes.J.geometry}
          material={materials["Material.003"]}
        >
        <meshStandardMaterial 
            color="#e3e3e3" 
            metalness={1} 
            roughness={0}
            attach="material"
            bumpMap={bumpMap}
            roughnessMap={roughnessMap}
            // map={colorMap}
            metalnessMap={metalnessMap}
            // normalMap={normalMap}
            
        />
        </mesh>
        <mesh
          name="J_1"
          castShadow
          receiveShadow
          geometry={nodes.J_1.geometry}
          material={materials["Material.003"]}
        >
        <meshStandardMaterial 
            color="#e3e3e3" 
            metalness={1} 
            roughness={0}
            attach="material"
            bumpMap={bumpMap}
            roughnessMap={roughnessMap}
            // map={colorMap}
            metalnessMap={metalnessMap}
            // normalMap={normalMap}
            
        />
        </mesh>
        <mesh
          name="J_2"
          castShadow
          receiveShadow
          geometry={nodes.J_2.geometry}
          material={materials["Material.003"]}
        >
        <meshStandardMaterial 
            color="#e3e3e3" 
            metalness={1} 
            roughness={0}
            attach="material"
            bumpMap={bumpMap}
            roughnessMap={roughnessMap}
            // map={colorMap}
            metalnessMap={metalnessMap}
            // normalMap={normalMap}
            
        />
        </mesh>
      </group>
    </group>
  );
}

useGLTF.preload("/models/JS-logo.glb");
